import { AgentNameProvider } from './agentName'
import { FleetDesktopPlacement } from './FleetDesktopPlacement'
import { MvpMobilePlacement } from './MvpMobilePlacement'
import { DESKTOP_WIDTH, MOBILE_WIDTH, OptionSection } from './OptionSection'

/** No mascot at MVP either: the agent answers to the brand. */
const MVP_NAME = 'Cai'

/** What ships first — web only, with the parts that are not built yet marked. */
export function MvpSection({ shellClass }: { shellClass: string }) {
  return (
    <AgentNameProvider name={MVP_NAME}>
      <OptionSection
        title="Fallback"
        panes={[
          {
            label: 'Desktop',
            width: DESKTOP_WIDTH,
            content: (
              <FleetDesktopPlacement notificationId={0} className={shellClass} plainAgent mvp notInsured />
            ),
          },
          {
            label: 'Mobile web',
            width: MOBILE_WIDTH,
            content: <MvpMobilePlacement className={shellClass} />,
          },
        ]}
      />
    </AgentNameProvider>
  )
}
